<template>

<div class="container-fluid row" id="cadastro">
    <!-- <div style="max-width: 500px"> -->
                    <div class="card pb-0 col-sm-12 col-md-12 col-lg-6 col-xs-12">
                        <!-- <div >
                            <img class="img-fluid" :src="require('@/assets/img/logo-login.png')"  alt="brasão" width="100%" height="100%" >
                        </div> -->
                        <div class="p-2" v-if="msgErro.length > 0">
                            <div class="alert alert-danger " role="alert"  v-if="msgErro.length > 0">
                                <div class="p-1" v-if="msgErro.length > 0" v-for="erro in msgErro" :key="erro">
                                   <span v-html="erro"></span> 
                                </div>
                                <div v-else>>
                                    {{ msgErro }}
                                </div>
                            </div>
                        </div>
                        <div class="p-2" v-if="msgInfo.length > 0">
                            <div class="alert alert-info " role="alert"  v-if="msgInfo.length > 0">
                                <div class="p-1" v-if="msgInfo.length > 0" v-for="info in msgInfo" :key="info">
                                   <span v-html="info"></span> 
                                </div>
                                <div v-else>>
                                    {{ msgInfo }}
                                </div>
                            </div>
                        </div>

                        <!-- Scrollable modal -->
                        
                        
                        <div class="card-body">
                            <form  action="" @submit.prevent="onSubmit()" >
                                <div class="modal fade " id="modalMensagemCofirmacaoDaInscricao"  tabindex="-1">
                                    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                                        <div class="modal-content">
                                            <div class="modal-header bg-success">
                                                <h5 class="modal-title text-light">Sua inscrição foi realizada com sucesso!!!</h5>
                                            </div>
                                            <div class="modal-body p-4" style="text-align: justify;">
                                                <p v-if="dados.dadosFuncionario.cnsexo === 'M'">Prezado,&nbsp;<span>{{dados.dadosFuncionario.nmfuncion.split(' ')[0]}}</span> </p>
                                                <p v-if="dados.dadosFuncionario.cnsexo === 'F'">Prezada,&nbsp;<span>{{dados.dadosFuncionario.nmfuncion.split(' ')[0]}}</span> </p>
                                                <p v-if="dados.dadosDaConfiguracao.tpcargo === 1">A sua inscrição para o "1º cargo" está concluída.</p>
                                                <p v-if="dados.dadosDaConfiguracao.tpcargo === 2">A sua inscrição para a "Extensão de carga horária" está concluída.</p>
                                                <p v-if="dados.dadosDaConfiguracao.tpcargo === 3">A sua inscrição para "PEB 40hs" está concluída.</p>
                                                <div class="p-2 pb-3">
                                                    <p class="text-center h4 text-danger">Atenção!!!!!</p>
                                                    <p class="h6 text-center text-danger"> A inscrição é apenas a <strong>primeira</strong> fase do processo.</p>
                                                    <p class="h6 text-center text-danger">
                                                        Nela, você escolhe qual cargo está almejando e tem a possibilidade de visualizar e 
                                                        favoritar as aulas que estão disponíveis. 
                                                    </p>
                                                </div>
                                                <p class="text-justify">
                                                    É&nbsp;<strong>essencial</strong>&nbsp;que você volte no dia&nbsp;<strong>{{dataDoRanking}}</strong>&nbsp;
                                                    para a segunda fase do processo.
                                                </p>
                                                <p class="text-justify">
                                                   Neste momento será divulgado, dentro do sistema, o seu&nbsp;<strong>agendamento (data e hora)</strong>&nbsp;para efetivação das suas aulas.
                                                    
                                                </p>
                                                <p class="text-center h5">
                                                    Por favor, fique <span v-if="dados.dadosFuncionario.cnsexo === 'M'">atento</span> 
                                                    <span v-if="dados.dadosFuncionario.cnsexo === 'F'">atenta</span> 
                                                    ao cronograma!
                                                </p>
                                                
                                            </div>
                                            <div class="modal-footer" style="justify-content: center">
                                                <router-link :to="{
                                                                    name: 'distribuicao-de-aulas', 
                                                                    params: {
                                                                                ...this.dados.dadosFuncionario,
                                                                                tipodistribuicao1: this.tipodistribuicao1,
                                                                                tipodistribuicaoextensaoch: this.tipodistribuicaoextensaoch,
                                                                                tipodistribuicaoPEB40h: this.tipodistribuicaoPEB40h,
                                                                                aaletivo: this.dados.aaletivo,
                                                                                cdlogin: this.dados.cdlogin,
                                                                                
                                                                            }
                                                                    }">
                                                     <button type="button" class="btn btn-primary" @click="closeModal()">OK</button>
                                                </router-link>
                                            </div>

                                        </div>
                                        
                                    </div>
                                </div>
                                <div class=row>
                                    <div class="form-group p-2 col-12 col-sm-12">
                                        <label for="aaletivo" class="p-1">Ano letivo</label>
                                        <input type="text" v-model.trim="dados.aaletivo" :disabled="true" class="form-control" name="aaletivo" >
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group p-2 col-12">
                                        <label for="cdlogin" class="p-1">Matrícula</label>
                                        <input type="text" v-model.trim="dados.cdlogin" :disabled="true" class="form-control" name="cdlogin">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group p-2 col-12">
                                        <label for="nmfuncion" class="p-1">Nome do funcionário</label>
                                        <input type="text" v-model.trim="dadosFuncionario.nmfuncion" :disabled="true" class="form-control" name="nmfuncion" >
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group p-2 col-12">
                                        <label for="dsgcargo" class="p-1">Grupo cargo</label>
                                        <input type="text" v-model.trim="grupoDeCargo" 
                                            :disabled="true" class="form-control" name="dsgcargo">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group p-2 col-12">
                                        <label for="cdcargo" class="p-1">Cargo</label>
                                        <input type="text" v-model.trim="dscargo" :disabled="true" class="form-control" name="cdcargo" >
                                    </div>
                                </div>
                                <div class="row" >
                                    <div class="form-group p-2 col-12">
                                        <label v-if="dados.dadosFuncionario.especialidades.length === 1" for="cdespecia" class="p-1">Especialidade</label>
                                        <label v-if="dados.dadosFuncionario.especialidades.length > 1" for="cdespecia" class="p-1">Especialidades</label>
                                        <ul class="list-group p-0" name="cdespecia" >
                                            <li :disabled="true" v-for="especialidade in dados.dadosFuncionario.especialidades" :key="especialidade.cdespecia" class="list-group-item list-group-item-secondary" aria-disabled="true">
                                                    {{ especialidade.dsespecia }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="row">
                                        <label class="form-check-label p-2" for="cdjustifi">
                                            Você está afastado(a) da sala de aula? Se sim, selecione a justificativa
                                            <span>
                                                <v-tooltip top color="#315E7E">
                                                    <!-- <i class="fas fa-bell fa-lg" style=" border-color: 0; color: #E5E5E5;"></i> -->
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                color="#E5E5E5"
                                                            >mdi-bell</v-icon>
                                                        </template>
                                                    <span>Atenção! A SME pode modificar ou retirar sua justificativa aqui informada caso seja necessário. Qualquer questionamento,<br>
                                                        entrar em contato com a SEMCOF na Secretaria Municipal de Educação pelo telefone (31) 3829-8046. (Tratar com Kécia) </span>
                                                </v-tooltip> 
                                            </span>
                                        </label>
                                    <div class="form-group p-2" id="cdjustifi">
                                        <select v-model="cdjustifi" class="form-select" aria-label="Default select example">
                                            <option value= "" selected></option>
                                            <option value="14">CEDIDO SEM ONUS</option>
                                            <option value="3">COORDENADOR</option>
                                            <option value="1">DIRETOR</option>
                                            <option value="2">DIRETOR ADJUNTO</option>
                                            <option value="4">EQUIPE DIRETIVA DE OUTRA UNIDADE</option>
                                            <option value="12">FERIAS PREMIO</option>
                                            <option value="15">LIBERADO PARA SINDICATO</option>
                                            <option value="11">LICENÇA MATERNIDADE</option>
                                            <option value="10">LICENÇA SAÚDE INSS</option>
                                            <option value="13">LICENÇA SEM VENCIMENTO</option>
                                            <option value="20">REMANEJADO PARA AEE</option>
                                            <option value="28">REMANEJADO PARA O CENAM</option>
                                            <option value="9">UNIDADES ADMINISTRATIVAS DA SME</option>
                                        </select>

                                    </div>
                                </div>
                                <div class="p-2">
                                    <label class="form-check-label" for="tipodistribuicao">Distribuições que irá se inscrever:*</label>
                                    <div class="form-check" id="tipodistribuicao">
                                        <input v-model="tipodistribuicao1" class="form-check-input" type="checkbox"  id="tipodistribuicao1" :disabled="!dados.ehPermitidoPrimeiroCargo">
                                        <label class="form-check-label" for="tipodistribuicao1">1º cargo (20h/semanais)</label>
                                    </div>
                                    <div class="form-check">
                                        <input v-model="tipodistribuicaoextensaoch" class="form-check-input" type="checkbox"  id="tipodistribuicaoextensaoch" :disabled="!dados.ehPermitidoExtensaoCH">
                                        <label class="form-check-label" for="tipodistribuicaoextensaoch">Extensão de carga horária</label>
                                    </div>
                                    <div class="form-check">
                                        <input v-model="tipodistribuicaoPEB40h" class="form-check-input" type="checkbox"  id="tipodistribuicaoPEB40h" :disabled="!dados.ehPermitidoPEB40Hs" >
                                        <label class="form-check-label" for="tipodistribuicaoPEB40h">PEB 40h</label>
                                    </div>
                                </div>
                                <!-- <router-link :to="{path: '/distribuicao-de-aulas', params:{ ...dadosFuncionario, tipodistribuicao1, tipodistribuicaoextensaoch, tipodistribuicaoPEB40h } }"  > -->
                                    <div v-if="!reload" class="p-4 pb-1 col-12 d-grid gap-2">
                                        <button type="submit" class="btn btn-primary btn-lg" :disabled="!dados.ehPermitidoPrimeiroCargo && !dados.ehPermitidoExtensaoCH && !dados.ehPermitidoPEB40Hs">Confirmar</button>
                                    </div>
                                    <div v-if="reload" class="p-4 pb-4 col-12 d-grid gap-2">
                                        <button class="btn btn-primary btn-lg" type="button" disabled>
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Efetuando a inscrição, por favor aguarde...
                                        </button>
                                    </div>
                                <!-- </router-link> -->
                                <router-link :to="{ path: '/'}">
                                    <div class="p-4 pt-0 col-12 d-grid gap-2">
                                        <button type="submit" class="btn btn-voltar btn-lg">Voltar</button>
                                    </div>
                                </router-link>
                            </form>
                        </div>
                    </div>
    <!-- </div> -->


</div>
  
</template>

<script>
import distribuicao from '../api/distribuicao'
import { mapActions, mapGetters } from 'vuex'
import { Modal } from 'bootstrap'
import moment from 'moment'
import {comprovanteInscricao} from '../reports/comprovanteInscricao';

export default {
    name: 'Cadastro',

    data: () => ({
        cdlogin: '',
        // dssenha: '',
        msgErro: [],
       msgInfo: [],
        tipodistribuicao1: false,
        tipodistribuicaoextensaoch: false,
        tipodistribuicaoPEB40h: false,
        dadosFuncionario: [],
        dadosDaConfiguracao: [],
        aaletivo: '',
        ehPermitidoPrimeiroCargo: true,
        ehPermitidoExtensaoCH: true,
        ehPermitidoPEB40Hs : true,
        cdjustifi: '',
        dssenha: '',
        edemail: '',
        loginSemLDAP: '',
        reload: '',
        modal: '',
        dataDoRanking: '',
        grupoDeCargo: '',
        dscargo: '',
        
    }),

    async beforeRouteEnter(to, from, next) {
        if(sessionStorage.cdlogin)
        {
           if (Object.keys(to.params).length === 0)
             next('/')
           else
            next()
        }
        else {
            next('/')
        }

        
    },
    async created() {
        
        this.cdlogin = sessionStorage.getItem('matricula')
        await this.atualizarDados({cdlogin : this.cdlogin, dstoken: this.getToken })
        this.dadosFuncionario = this.dados.dadosFuncionario
        this.grupoDeCargo = (this.dados.dadosFuncionario.efetivo) ? this.dados.dadosFuncionario.dsgcargoef : this.dados.dadosFuncionario.dsgcargo
        this.dscargo = (this.dados.dadosFuncionario.efetivo) ? this.dados.dadosFuncionario.dscargoef : this.dados.dadosFuncionario.dscargo
        this.dadosDaConfiguracao = this.dados.dadosDaConfiguracao
        this.ehPermitidoPrimeiroCargo = this.dados.ehPermitidoPrimeiroCargo
        this.ehPermitidoExtensaoCH = this.dados.ehPermitidoExtensaoCH
        this.ehPermitidoPEB40Hs = this.dados.ehPermitidoPEB40Hs
        this.cdjustifi = this.dados.dadosDaInscricao.cdjustifi
        this.tipodistribuicao1 = (this.dados.dadosDaInscricao.idcargo1 === 'S') ? true : false
        this.tipodistribuicaoextensaoch = (this.dados.dadosDaInscricao.idextch === 'S') ? true : false
        this.tipodistribuicaoPEB40h = (this.dados.dadosDaInscricao.idpeb40hs === 'S') ? true : false
        this.dataDoRanking = moment(this.dados.dadosDaConfiguracao.dtranking).format('DD/MM/YYYY')
        this.msgInfo = [`A inscrição que está ocorrendo no momento é "${this.dadosDaConfiguracao.dstpcargo}"
                        e ela acontece até o dia ${moment(this.dadosDaConfiguracao.dtinscfin).format('DD/MM/YYYY')}.`]
        
        if (    (this.dadosDaConfiguracao.tpcargo === 1 && this.ehPermitidoPrimeiroCargo === false)||
                (this.dadosDaConfiguracao.tpcargo === 2 && this.ehPermitidoExtensaoCH === false) ||
                (this.dadosDaConfiguracao.tpcargo === 3 && this.ehPermitidoPEB40Hs === false)
            )  {
                this.msgInfo.push('A inscrição não está habilitada para esta matrícula, qualquer dúvida, gentileza procurar a Secretaria Municipal de Educação, seção SEMCOF (ramal 8046)')
        }

        
    },

    mounted() {
        
        this.modal = new Modal(document.getElementById('modalMensagemCofirmacaoDaInscricao'), {
            backdrop: 'static'
        })
        this.closeModal();

        this.dssenha = this.$route.params.dssenha
        this.edemail = this.$route.params.edemail
        this.loginSemLDAP = this.$route.params.loginSemLDAP
               

    },

    computed: {
        ...mapGetters(['dados', 'getToken']),
    },

    methods: {
        ...mapActions(['atualizarDados']),
        openModal() {
            this.modal.show()
        },
        closeModal() {
            this.modal.hide()
        },
        validarFormulario()
        {
            let erros = []
            //console.log('QuerySelector("#tipodistribuicao1").disabled =', )
            if (
                ( this.dados.ehPermitidoPrimeiroCargo !== this.tipodistribuicao1 && this.dados.ehPermitidoPrimeiroCargo === true  ) ||
                (this.dados.ehPermitidoExtensaoCH !== this.tipodistribuicaoextensaoch && this.dados.ehPermitidoExtensaoCH === true) ||
                ( this.dados.ehPermitidoPEB40Hs !== this.tipodistribuicaoPEB40h && this.dados.ehPermitidoPEB40Hs === true )
            )
            {
                erros = ['Selecione as distribuições que irá pleitear']
            }
            return erros;
        },

        onSubmit() {
            this.reload = true;
            // return false;
            const erros = this.validarFormulario();
            if (erros.length > 0) {
                this.msgErro = erros
                this.reload = false;
                return false ;
            }
            else {
                this.msgErro = []
                distribuicao.cadastrar({
                    ...this.dados.dadosFuncionario,
                    tipodistribuicao1: this.tipodistribuicao1,
                    tipodistribuicaoextensaoch: this.tipodistribuicaoextensaoch,
                    tipodistribuicaoPEB40h: this.tipodistribuicaoPEB40h,
                    cdjustifi: this.cdjustifi,
                    aaletivo: this.dados.aaletivo,
                    cdlogin: this.dados.cdlogin,
                    dstoken: this.getToken,
                    dssenha: this.dssenha,
                    edemail: this.edemail,
                    loginSemLDAP: this.loginSemLDAP,
                }).then( resposta => {
                    this.reload = false;
                    this.emitirComprovante();
                    this.openModal();

                }).catch(erros => {
                    this.$router.push('/cadastro')
                    this.msgErro = ['Erro interno no servidor'];
                    this.reload = false;
                })
            }
        },
        async emitirComprovante() {
            const dados = {
                dadosDaInscricao: this.dados.dadosDaInscricao,
                dstpcargo: this.dados.dadosDaConfiguracao.dstpcargo,
                dadosFuncionario: this.dados.dadosFuncionario,
            }
            const dd = await comprovanteInscricao(dados)
            pdfMake.createPdf(dd).download();
        }

        
    }

}
</script>

<style>

html, body {
    margin: 0;
    width: 100%;
    height: 100%;
    
}
#app {
    margin: 0;
    height: 100%;
}
#cadastro {
    background-image: url("../assets/img/login-bg.png");
    background-repeat: no-repeat;
    background-size: cover;
    max-width: 100%;
    margin: 0;
    height: 100vh;
    width: 100%;
    max-height: 100%;
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-group-lg > .btn, .btn-lg {
    padding: .5rem 1rem;
    font-size: 18px;
    border-radius: .3rem;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.btn-primary {
    color: #fff;
    background-color: #315E7E;
    border-color: #315E7E;
}

.btn-voltar {
    color: #fff;
    background-color: #25848c;
    border-color: #25848c;
    /* text-decoration: none; */
}
a.router-link-active {
   text-decoration: none;
}
.btn-voltar:hover {
    color: white;
    background-color: #3F929A;
    border-color: #3F929A;
}

</style>